import React from 'react';
import ZeroTrustExplorer from './components/ZeroTrustExplorer';

function App() {
  return (
    <div className="App">
      <ZeroTrustExplorer />
    </div>
  );
}

export default App;